const TogglePassword = () => {
  const authInputWrappers = [...document.querySelectorAll(".auth__input-wrapper")];

  authInputWrappers.forEach((authInputWrapper) => {
    const passwordInput = authInputWrapper.querySelector("input[type='password']");
    const toggleBtn = authInputWrapper.querySelector(".auth__toggle-password-btn");
    const openIcon = authInputWrapper.querySelector(".open-password-icon");
    const hideIcon = authInputWrapper.querySelector(".hide-password-icon");

    if (toggleBtn && passwordInput) {
      toggleBtn.addEventListener("click", () => {
        const isPasswordVisible = passwordInput.getAttribute("type") === "password";
        passwordInput.setAttribute("type", isPasswordVisible ? "text" : "password");

        if (isPasswordVisible) {
          hideIcon.classList.remove("d-none");
          hideIcon.classList.add("d-block");
          openIcon.classList.add("d-none");
          openIcon.classList.remove("d-block");
        } else {
          openIcon.classList.remove("d-none");
          openIcon.classList.add("d-block");
          hideIcon.classList.add("d-none");
          hideIcon.classList.remove("d-block");
        }
      });
    }
  });
}

export default TogglePassword;
